import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "../../i18n/useTranslation";
import { Typography } from "antd";

const { Text } = Typography;

const Overview = () => {
  const { t } = useTranslation();

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-xl font-semibold text-[#004b67]">{t("accountOverviewTitle")}</h1>
        <div className="mt-2 h-px bg-[#e6f7ff]" />
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div className="bg-white rounded-lg shadow-sm border border-gray-100 p-5">
          <h2 className="text-sm font-medium text-gray-500 mb-3">{t("accountStatus")}</h2>
          <div className="space-y-2">
            <div className="flex justify-between">
              <Text type="secondary">{t("currentVersion")}</Text>
              <Text strong>Pro</Text>
            </div>
            <div className="flex justify-between">
              <Text type="secondary">{t("accountStatus")}</Text>
              <Text strong>{t("accountStatusExpiringSoon")}</Text>
            </div>
            <div className="flex justify-between">
              <Text type="secondary">{t("expiryTime")}</Text>
              <Text>{t("expiryTimeValue")}</Text>
            </div>
            <div className="flex justify-between">
              <Text type="secondary">{t("remainingTime")}</Text>
              <Text>{t("remainingTimeValue")}</Text>
            </div>
          </div>
        </div>
        <div className="bg-white rounded-lg shadow-sm border border-gray-100 p-5">
          <h2 className="text-sm font-medium text-gray-500 mb-3">{t("accountStatus")}</h2>
          <div className="space-y-2">
            <div className="flex justify-between">
              <Text type="secondary">{t("currentVersion")}</Text>
              <Text strong>Pro</Text>
            </div>
            <div className="flex justify-between">
              <Text type="secondary">{t("accountStatus")}</Text>
              <Text strong>{t("accountStatusExpiringSoon")}</Text>
            </div>
            <div className="flex justify-between">
              <Text type="secondary">{t("expiryTime")}</Text>
              <Text>{t("expiryTimeValue")}</Text>
            </div>
            <div className="flex justify-between">
              <Text type="secondary">{t("remainingTime")}</Text>
              <Text>{t("remainingTimeValue")}</Text>
            </div>
          </div>
        </div>
      </div>

      <div className="bg-white rounded-lg shadow-sm border border-gray-100 p-5">
        <h2 className="text-sm font-medium text-gray-500 mb-4">{t("licenseSummary")}</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
          <div className="flex justify-between">
            <Text type="secondary">{t("licenseType")}</Text>
            <Text strong>{t("licenseTypeTeam")}</Text>
          </div>
          <div className="flex justify-between">
            <Text type="secondary">{t("deviceQuota")}</Text>
            <Text>{t("usedTotal")}</Text>
          </div>
          <div className="flex justify-between">
            <Text />
            <Text strong>3/5</Text>
          </div>
          <div className="flex justify-between">
            <Text />
            <Text>{t("multiDevice")}</Text>
          </div>
        </div>
        <div className="pt-3 border-t border-gray-100">
          <div className="flex justify-between items-center mb-2">
            <Text type="secondary">{t("latestDevice")}</Text>
            <Link to="/account/devices" className="text-sm text-[#004b67] hover:underline">
              {t("viewAllDevices")} →
            </Link>
          </div>
          <div className="flex justify-between">
            <Text strong>{t("deviceNameExample")}</Text>
            <Text type="secondary">{t("lastOnline")} · {t("lastOnlineAgo")}</Text>
          </div>
        </div>
      </div>

      <div className="bg-white rounded-lg shadow-sm border border-gray-100 p-5">
        <h2 className="text-sm font-medium text-gray-500 mb-3">{t("importantNotices")}</h2>
        <ul className="space-y-2 text-sm text-gray-600">
          <li>{t("noticeTrialOnce")}</li>
          <li>{t("noticeOfflineLimit")}</li>
        </ul>
      </div>
    </div>
  );
};

export default Overview;
